import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { FavouritesConfig } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { DeviceService, PlainLinkComponent } from '@frontend/vanilla/core';

import { FavouriteEventToggleComponent } from '../../favourites/toggle/favourite-event-toggle.component';
import { GridScoreboardComponent } from '../../grid-scoreboard/components/grid-scoreboard.component';
import { RemoveHrefDirective } from '../../navigation-core/remove-href.directive';
import { UrlHelperService } from '../../navigation-core/url-helper.service';
import { LeftNavType, NavEventModel } from '../event-details-common.models';
import { TreeEventDetailComponent } from './tree-event-detail.component';
import { TreeMarketComponent } from './tree-market.component';

@Component({
    selector: 'ms-tree-event',
    templateUrl: 'tree-event.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        RemoveHrefDirective,
        FavouriteEventToggleComponent,
        TreeEventDetailComponent,
        GridScoreboardComponent,
        TreeMarketComponent,
        PlainLinkComponent,
    ],
})
export class TreeEventComponent implements OnInit, OnChanges {
    @HostBinding('class') className = 'tree-event ms-active-highlight';
    @Input() event: NavEventModel;
    @Input() showMarkets: boolean;
    @Input() leftNavType: LeftNavType;
    @Input() updatedFavourites: string[] = [];
    @Input() hideFavourites = false;

    @Output() select = new EventEmitter<NavEventModel>();
    eventUrl: string;
    shouldRemoveHref: Nullable<boolean>;
    showHoverFavoriteToggle = false;
    isExpanded = false;

    constructor(
        private urlHelper: UrlHelperService,
        private favouritesConfig: FavouritesConfig,
        private deviceService: DeviceService,
    ) {}

    ngOnInit(): void {
        this.eventUrl = this.urlHelper.getEventUrl(this.event.data);
        this.showHoverFavoriteToggle =
            this.favouritesConfig.isLiveFavouritesEnabled && !this.hideFavourites && !this.deviceService.isTouch ? true : false;
        this.shouldRemoveHref = this.urlHelper.shouldRemoveHref();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.event && !changes.event.isFirstChange()) {
            const newEvent: NavEventModel = changes.event.currentValue;
            this.eventUrl = this.urlHelper.getEventUrl(newEvent.data);
        }
    }

    selectEvent(): void {
        this.select.emit(this.event);
    }
}
